// extracted by mini-css-extract-plugin
export default {"container":"ChartCardTitle_container__kPM9f","titleContainer":"ChartCardTitle_titleContainer__2Ly0p","pieContainer":"ChartCardTitle_pieContainer__TDzM9"};